var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3301 23.25C18.5433 23.25 23.5801 18.2132 23.5801 12C23.5801 5.7868 18.5433 0.75 12.3301 0.75C6.11687 0.75 1.08008 5.7868 1.08008 12C1.08008 18.2132 6.11687 23.25 12.3301 23.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3301 18.75C16.058 18.75 19.0801 15.7279 19.0801 12C19.0801 8.27208 16.058 5.25 12.3301 5.25C8.60216 5.25 5.58008 8.27208 5.58008 12C5.58008 15.7279 8.60216 18.75 12.3301 18.75Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3301 14.25C13.5727 14.25 14.5801 13.2426 14.5801 12C14.5801 10.7574 13.5727 9.75 12.3301 9.75C11.0874 9.75 10.0801 10.7574 10.0801 12C10.0801 13.2426 11.0874 14.25 12.3301 14.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3301 9.75V5.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1902 11.3051L5.91016 9.91406",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0083 13.8198L8.3623 17.4608",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6533 13.8198L16.2983 17.4608",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4702 11.3051L18.7502 9.91406",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 0 0",
    to: "360 0 0",
    repeatCount: "indefinite"
  })));
};
export default SvgLoader;